/**
 * App base path utilities.
 *
 * Vite sets BASE_URL to "/portal/" in production builds and "/" in dev.
 * Clerk navigates outside React Router, so its URL props need full absolute
 * paths (e.g. "/portal/sign-in" in production, "/sign-in" in dev).
 */

const basename = import.meta.env.BASE_URL.replace(/\/+$/, "") || "";

/** Resolve a route path into an absolute URL that includes the app basename. */
export function resolveAppUrl(path: string): string {
  return `${basename}${path}`;
}
